import { observer } from "mobx-react-lite"
import { FC, useContext, useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { Context } from "../.."
import Modal from "../../components/Modal"

import styles from "../../styles/AdminManager.module.scss"
import CoreManager from "./manager/CoreManager"
import HomeManager from "./manager/HomeManager"
import PagesManager from "./manager/PagesManager"
import RoomsManager from "./manager/RoomsManager"
import SalesManager from "./manager/SalesManager"

enum ManagerPage {
  HOME = "HOME",
  SALES = "SALES",
  PAGES = "PAGES",
  ROOMS = "ROOMS",
  SETTINGS = "SETTINGS"
}

const ManagerPageTitle = {
  HOME: "Главная", SALES: "Акции", PAGES: "Страницы", ROOMS: "Номера", SETTINGS: "Настройки"
}

const AdminManager: FC = () => {

  const { store, adminStore } = useContext(Context)
  const location = useLocation()

  const [page, setPage] = useState(ManagerPage.PAGES as ManagerPage)
  const [pageTitle, setPageTitle] = useState(ManagerPageTitle.PAGES as string)
  
  const [isLogoutVisible, setIsLogoutVisible] = useState(false)
  const [visible, setVisible] = useState(false)
  const [visibleOp, setVisibleOp] = useState(false)

  const openManager = () => {
    setVisible(prev => prev = true)
    if (location.pathname.includes("/promo")) {
      setPage(ManagerPage.SALES)
    } else if (location.pathname == "/" || location.pathname == "/summer" || location.pathname == "/winter") {
      setPage(ManagerPage.PAGES)
    } else {
      setPage(ManagerPage.PAGES)
    }
    setTimeout(() => {
      setVisibleOp(prev => prev = true)
    }, 100)
  }
  
  const closeManager = () => {
    setVisibleOp(prev => prev = false)
    setTimeout(() => {
      setVisible(prev => prev = false)
    }, 300)
  }

  const logout = () => {
    store.logout()
    window.location.reload()
  }

  useEffect(() => {
    setPageTitle(prev => prev = ManagerPageTitle[page])
  }, [page])

  useEffect(() => {

  }, [])

  return (
    <>
      <div 
        className={styles.manager_btn + (store.theme == "winter" && !location.pathname.includes("/summer") ? " " + styles.winter : "")}
        onClick={() => openManager()}><div><i className="far fa-wrench"></i></div></div>
    
      <div className={styles.manager} style={{opacity: visibleOp ? "1" : "0", display: visible ? "flex" : "none"}}>
        <div className={styles.manager_wrap}>
          <div className={styles.manager_sidebar + (store.backTheme == "summer" ? " " + styles.summer : "")}>
            <div className={styles.manager_sidebar__logo}>RoyalResort <b>CMS</b></div>
            <div className={styles.manager_sidebar__menu}>
              <div className={page == ManagerPage.PAGES ? styles.active : ""} onClick={() => setPage(ManagerPage.PAGES)}>{ManagerPageTitle.PAGES}</div>
              <div className={page == ManagerPage.ROOMS ? styles.active : ""} onClick={() => setPage(ManagerPage.ROOMS)}>{ManagerPageTitle.ROOMS}</div>
              <div className={page == ManagerPage.SALES ? styles.active : ""} onClick={() => setPage(ManagerPage.SALES)}>{ManagerPageTitle.SALES}</div>
              <div className={page == ManagerPage.SETTINGS ? styles.active : ""} onClick={() => setPage(ManagerPage.SETTINGS)}>{ManagerPageTitle.SETTINGS}</div>
            </div>
            <div className={styles.manager_sidebar__logout} onClick={() => setIsLogoutVisible(true)}><i className="far fa-right-from-bracket"></i> Выйти</div>
          </div>
          <div className={styles.manager_body}>
            <div className={styles.manager_body__header}>
              <div className={styles.mbh_title}>
                <div>Панель Управления</div>
                <div>{pageTitle}</div>
              </div>
              <div className={styles.mbh_close} onClick={() => closeManager()}><i className="fas fa-xmark"></i></div>
            </div>
            <div className={styles.manager_body__content}>
              {page == ManagerPage.HOME ? <HomeManager /> : <></>}
              {page == ManagerPage.SALES ? <SalesManager /> : <></>}
              {page == ManagerPage.PAGES ? <PagesManager /> : <></>}
              {page == ManagerPage.ROOMS ? <RoomsManager /> : <></>}
              {page == ManagerPage.SETTINGS ? <CoreManager /> : <></>}
            </div>
          </div>
        </div>
      </div>

      <Modal
        visible={isLogoutVisible}
        title="Выйти из ПУ"
        content={<>
          <div className="modal_text">
            <p>Вы действительно хотите выйти из Панели Управления сайтом?</p>
          </div>
          <div className="modal_action">
            <div>
              <button onClick={() => logout()} style={{marginBottom: "0px"}}>Выйти</button>
            </div>
          </div>
        </>}
        onClose={() => setIsLogoutVisible(false)} />
    </>
  )
}

export default observer(AdminManager)